var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 227.447,
    height: 53,
    viewBox: "0 0 227.447 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23775",
    "data-name": "Group 23775",
    transform: "translate(-375.462 -19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14055",
    "data-name": "Path 14055",
    d: "M19.8,0,18.6-5.027h-8.15L9.16,0H.267L9.674-27.308H19.881L28.736,0Zm-5.18-21.366h-.19a13.266,13.266,0,0,1-.267,1.5q-.229,1.047-2.3,8.988h5.218l-1.9-7.427A23.486,23.486,0,0,1,14.625-21.366ZM57.681-14a15.067,15.067,0,0,1-1.742,7.341,12.008,12.008,0,0,1-4.98,4.923A15.576,15.576,0,0,1,43.494,0H31.935V-27.308H43.247Q57.681-27.308,57.681-14Zm-8.741.076a7.859,7.859,0,0,0-.809-3.6A5.855,5.855,0,0,0,45.817-20a6.914,6.914,0,0,0-3.542-.876H40.162V-6.437h2.3a5.929,5.929,0,0,0,4.713-2.028A8.031,8.031,0,0,0,48.94-13.92ZM86.531,0V-14.968q0-2.114.133-4.646l.057-1.257h-.229q-.609,3.218-.933,4.456L81.542,0H73.811L69.6-16.225q-.171-.609-.9-4.646h-.229q.267,6.4.267,8V0H61.528V-27.308H73.849L77.6-12.473a18.31,18.31,0,0,1,.352,1.857q.219,1.4.276,2.161h.114q.209-1.733.667-4.094l3.5-14.758h12.13V0Zm13.482,0V-27.308h8.227V0Zm32.678,0-9.636-13.178A31.407,31.407,0,0,1,121.189-16h-.076q.114,2.019.114,4.532V0H113.61V-27.308h7.77l9.236,12.53q.171.248.419.59t.5.7q.248.362.467.7a4.334,4.334,0,0,1,.333.609h.076a24.749,24.749,0,0,1-.114-2.895V-27.308h7.617V0Z",
    transform: "translate(463 47)",
    fill: "#f28900"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23743",
    "data-name": "Group 23743",
    transform: "translate(41.455 -430.172)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "ASSIST",
    transform: "translate(334.545 497.172)",
    fill: "#707070",
    fontSize: 21,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ASSIST")), /*#__PURE__*/React.createElement("g", {
    id: "Group_23548",
    "data-name": "Group 23548",
    transform: "translate(334.007 449.172)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10462",
    "data-name": "Rectangle 10462",
    width: 9.369,
    height: 28.391,
    transform: "translate(29.429 0)",
    fill: "#f28900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13953",
    "data-name": "Path 13953",
    d: "M430.231,461.283l-.038-.053h.03V449.245h-8.337v7.792l-6.416,4.653h-.562l-6.416-4.653v-7.792h-8.337V461.23h.03l-.038.053,10.255,7.438v8.725h9.41v-8.607Z",
    transform: "translate(-358.155 -449.199)",
    fill: "#f28900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13954",
    "data-name": "Path 13954",
    d: "M346.256,449.172H334.007v10.807h9.369V457.04h2.636c3.326,0,5.353,1.7,5.353,6.327s-2.028,6.327-5.353,6.327h-2.636v-2.768h-9.369v10.637h12.249c10.179,0,14.722-5.88,14.722-14.2S356.435,449.172,346.256,449.172Z",
    transform: "translate(-334.007 -449.172)",
    fill: "#f28900"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.98d6a8bf5622b103d672f72e1f500c8c.svg";
export { ForwardRef as ReactComponent };